import * as Yup from 'yup';

export const validationSchema = Yup.object({
  file: Yup.mixed()
    .nullable()
});